export function stringifyJson(data: unknown): string {
  return JSON.stringify(data, (_key, v) => (typeof v === 'bigint' ? v.toString() : v), 2);
}

export function downloadJson(data: unknown, filename: string): void {
  const blob = new Blob([stringifyJson(data)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
